import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import VerificationModal from "../../Modals/verificationModal";
import { useState } from "react";

const UserList = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const users = [
    {
      id: 1,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      dob: "1995-08-12",
      count: "1250",
      redeemedCount: "100",
      date: "01 March 2025",
    },
    {
      id: 2,
      name: "John Smith",
      email: "john@example.com",
      phone: "+91 9000011111",
      dob: "1990-04-05",
      count: "1250",
      redeemedCount: "100",
      date: "01 March 2025",
    },
  ];

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>DOB</TableCell>
              <TableCell>Points Balance</TableCell>
              <TableCell>Redeemed Points</TableCell>
              <TableCell>Date Registered</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow hover key={user.id}>
                <TableCell>
                  <Box
                    component="a"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/manage-users/detail", { state: { user } });
                    }}
                    className="user_block click_action"
                  >
                    <p>
                      <b>{user.name}</b>
                      <span>{user.email} <img src="/static/images/tick_icon.svg" alt="verified" /> </span>
                      <span>{user.phone}</span>
                    </p>
                  </Box>
                </TableCell>
                <TableCell>{user.dob}</TableCell>
                <TableCell>
                  <span className="c_success">{user.count}</span>
                </TableCell>
                <TableCell>{user.redeemedCount}</TableCell>
                <TableCell>{user.date}</TableCell>
                <TableCell>
                  <SwitchToggle />
                </TableCell>
                <TableCell>
                  <div className="table_action_wrapper">
                  <div className="table_actions v2">
                    <IconButton
                      onClick={() => navigate("/manage-users/detail")}
                    >
                      <img src="/static/images/eye_icon.svg" alt="View" />
                    </IconButton>
                    <IconButton onClick={() => navigate("/manage-users/edit")}>
                      <img src="/static/images/edit2_icon.svg" alt="Edit" />
                    </IconButton>
                    <IconButton>
                      <img src="/static/images/trash2_icon.svg" alt="Edit" />
                    </IconButton>
                  </div>
                  <Button className="btn btn_primary sm" onClick={()=> setOpenModal(true)}> Verification</Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
        <VerificationModal open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
    </>
  );
};

export default UserList;
